import { DEFAULT_EMPTY_AVATAR } from "@constants";
import { replaceErrorAvatar } from "@helpers";
import clsx from "clsx";
import React from "react";
import { Placeholder, Stack } from "react-bootstrap";
import styles from "./styles/InstructorCard.module.css";

const InstructorCardPlaceholder = () => {
  // state

  // variables

  // logics before hooks

  // hooks

  // logics

  // UI partials

  // effects

  // render
  return (
    <div
      className={clsx(
        styles.instructorCard,
        "d-flex flex-column justify-content-between p-4 rounded border"
      )}
    >
      <Placeholder animation="glow">
        <div className={clsx(styles.tutorImg, "mb-2")}>
          <img
            src={DEFAULT_EMPTY_AVATAR}
            alt="avatar"
            className="m-auto"
            onError={replaceErrorAvatar}
          />
        </div>
        <Stack gap={2} className="align-items-center">
          <Placeholder size="lg" xs={8} />
          <Placeholder size="xs" xs={4} />
        </Stack>
      </Placeholder>
      <Placeholder animation="glow">
        <Stack
          gap={2}
          direction="horizontal"
          className="justify-content-center"
        >
          <Placeholder.Button xs={2} />
          <Placeholder.Button xs={2} />
          <Placeholder.Button xs={2} />
        </Stack>
      </Placeholder>
      <Placeholder animation="glow">
        <Stack
          gap={2}
          direction="horizontal"
          className="justify-content-center"
        >
          <Placeholder size="xs" xs={5} />
          <Placeholder size="xs" xs={3} />
        </Stack>
      </Placeholder>
    </div>
  );
};

/* required: display name */
InstructorCardPlaceholder.displayName = "InstructorCardPlaceholder";

/* required: props types */
InstructorCardPlaceholder.propTypes = {};

/* required: default props */
InstructorCardPlaceholder.defaultProps = {};

export { InstructorCardPlaceholder };
